const translations = {
    assetType: 'Type',
    lastActivity: 'Last Activity',
    lastEdited: 'Last Edited',
    loading: 'Loading',
    name: 'Name',
    noAssets: 'No Assets',
    noMoreAssets: 'No More Assets'
};

export default translations;
